import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const HandlingIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M16.8311 18.4004H19.5996V20.7998H4V18.4004H6.73926L7.9248 14.2002H15.5361L16.8311 18.4004ZM14.7969 11.7998H8.60254L10.8057 4H12.3965L14.7969 11.7998Z'
                fill='currentColor'
            />
        </>
    ),
})

HandlingIcon.displayName = 'HandlingIcon'
